export const Props = () => ({
  //--------------------------------------------------------------------------
  //                                      Объект поста
  //--------------------------------------------------------------------------
  post: {
    type: Object,
    required: true,
  }
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
});